import React from 'react';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { appStyles } from '../../../../styles';
import { UploadImage } from '../../../../assets';

export interface AttributeValues {
  backgroundImage?: string;
  textColor?: string;
  title?: string;
  ctaText?: string;
  describeText?: string;
  describeText2?: string;
}
interface PreviewProps {
  values: AttributeValues & any;
  isPreview?: boolean;
  height?: string;
  className?: string;
}

export const PreviewJustInClubhouse = (props: PreviewProps) => {
  const { values, isPreview, height, className } = props;
  const {
    backgroundImage,
    title,
    describeText,
    describeText2,
    background,
    titleColor,
    ctaTextColor,
    ctaBackgroundColor,
    ctaText,
  } = values;
  const isDefaultImage = backgroundImage === '' || !backgroundImage || !isPreview;

  const parseString = (str: string) => {
    const num: number = str.length;
    if (num > 75) {
      const newStr: string = str.substring(0, 75);
      return `${newStr}...`;
    }
    return str;
  };

  return (
    <StyledJustInClubhousePreview
      className={className}
      style={{ height: height || '300px', backgroundColor: background || '#fff' }}
    >
      <div>
        <div className={!isDefaultImage ? 'preview-ant-image' : 'preview-ant-image'}>
          <StyledLinearGradient />
          {!isDefaultImage ? (
            <img className="image-just-in-clubhouse" src={backgroundImage} alt="" />
          ) : (
            <div className="image-default">
              <img src={UploadImage} alt="" />
              <div className="describeText">{describeText}</div>
              <div className="describeText2">{describeText2}</div>
            </div>
          )}
          <div className="content-preview">
            <div>
              {title && (
                <div className="heading" style={{ color: titleColor || '#000' }}>
                  {parseString(title)}
                </div>
              )}
            </div>
            <div className="center">
              <Button
                className="btn-learn-more"
                style={{ background: ctaBackgroundColor || '#000', color: ctaTextColor || '#fff' }}
              >
                {ctaText || 'Watch Now'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </StyledJustInClubhousePreview>
  );
};

const StyledLinearGradient = styled.div`
  ${appStyles.fullWidthHeight}
  ${appStyles.borderRadiusPreview}
  position: absolute;
`;

const StyledJustInClubhousePreview = styled.div`
  margin: 2rem 1.5rem;
  min-height: 393px;
  position: relative;
  text-align: left;
  line-height: 1.2;
  display: flex;
  justify-content: center;
  flex-direction: column;
  & .content-preview {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  & .heading {
    margin-top: 16px;
    font-weight: 800;
    font-size: 16px;
    padding: 0 1rem;
    width: 100%;
    margin-bottom: 24px;
    padding-left: 16px;
    padding-right: 16px;
    text-align: center;
    white-space: pre-line;
  }
  & .btn-learn-more {
    font-weight: 600;
    border-radius: 25px;
    margin: 0 0 1rem 0.5rem;
    width: auto;
    height: 2.3rem;
    padding: 0 1rem;
    border: none;
  }
  & .image-border {
    border-bottom: 1px #c3c3c3 solid;
  }
  & .preview-ant-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0;
    height: 393px;
    & .image-just-in-clubhouse {
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 0;
    }
    & .image-default {
      justify-content: center;
      text-align: center;
      & img {
        width: 6rem;
        height: 6rem;
      }
      & .describeText {
        font-size: 17px;
        padding-top: 1rem;
        font-weight: 600;
      }
      & .describeText2 {
        font-size: 15px;
        padding-top: 0.5rem;
      }
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-brand {
    margin: 0.7rem 1rem;
    & .logo-tm {
      width: 2.5rem;
      padding-right: 10px;
      height: auto;
    }
    & .img-partner {
      padding-left: 10px;
      width: auto;
      max-height: 3rem;
    }
  }
  .uploadText {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 4rem;
    color: white;
  }
  .textContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .wrapper-text-preview {
    position: absolute;
    bottom: 20%;
    width: 100%;
    padding: 0 1rem;
  }
  & .title {
    font-size: 25px;
  }
  & .priceColor {
    display: block;
    font-size: 11px;
  }
  .promotion-preview {
    & .description {
      font-size: 25px;
    }
    & .title {
      font-size: 14px;
    }
  }
  & .wrapper-btn-preview {
    position: absolute;
    bottom: 8px;
    width: 100%;
    display: flex;
    padding: 0 1rem;
    & .button {
      border-radius: 1rem;
      background: #fff;
      color: #000;
      height: 30px;
      font-size: 16px;
      padding: 0.2rem 1.25rem 0 1.25rem;
    }
  }

  @media screen and (max-width: 1440px) {
    .text-preview {
      bottom: 13%;
    }
    & .description {
      font-size: 12px;
    }
    & .title {
      font-size: 21px;
    }

    .promotion-preview {
      & .description {
        font-size: 21px;
      }
      & .title {
        font-size: 15px;
      }
    }
  }
`;
